import { render, staticRenderFns } from "./PriTama05_Nico.vue?vue&type=template&id=3a689723&scoped=true&"
import script from "./PriTama05_Nico.vue?vue&type=script&lang=js&"
export * from "./PriTama05_Nico.vue?vue&type=script&lang=js&"
import style0 from "./PriTama05_Nico.vue?vue&type=style&index=0&id=3a689723&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a689723",
  null
  
)

export default component.exports